export default {"src":"/_next/static/media/Check.d01abc66.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};